/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: ReactToProp.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/23 @ 1620
 * ---
 * Description:
 */

import {useEffect} from "react";

interface Props<T> {
    value: T;
    onChange: (value: T) => void;
}

export const ReactToProp = <T extends unknown>(props: Props<T>) => {
    useEffect(() => {
        props.onChange(props.value);
    }, [props.value])

    return (
        <></>
    )
}